import React, { Component } from 'react';

import { Icon } from 'semantic-ui-react';

class MediaItem extends Component {
    render() {

        const figure = this.props.media.image;

        return (
            <div style={mediaBoxWrapper}>
                <a href={this.props.media.link} target="_blank">
                <div style={mediaBoxStyle}>
                    <React.Fragment>
                    <div style={greenBand} />
                    <div style={mediaMainBox}>
                        <div style={mediaHeaderBox}>
                            <h1 style={mediaHeaderStyle}>{ this.props.media.title + ", featured in " + this.props.media.publisher}</h1>
                        </div>
                        

                    </div> 
                    
                    <div style={linkIconBox}>

                        <Icon name='angle right' size='large' style={iconStyle}/>
                    </div>
                    </React.Fragment>
                </div>
                </a>
            </div>
        )
    }
}

const mediaBoxWrapper = {
    maxWidth: '550px',
    marginBottom: '40px',
    marginLeft: '14px',
    marginRight: '14px',
    flexGrow: '1'
}

const mediaBoxStyle = {
    maxWidth: '550px',
    borderRadius: '8px',
    backgroundColor: '#f2f2f2',
    boxShadow: '0px 10px 6px #e3e3e3',
    display: 'flex',
    flexFlow: 'row nowrap',
    overflow: 'hidden',
}

const greenBand = {
    width: '30px',
    display: 'tableCell',
    backgroundColor: '#b6c97b',
    flexShrink: '0'
}

const mediaMainBox = {
    padding: '12px 10px 12px 10px',
    maxWidth: '490px',
    minWidth: '0px',
    flex: '1 1 auto'
}

const mediaHeaderBox = {
}

const mediaHeaderStyle = {
    fontSize: '20px',
    color: 'black',
}


const linkIconBox = {
    width: '30px',
    position: 'relative',
    fontFamily: 'Heebo, sans-serif',
    fontSize: '16px',
}

const iconStyle = {
    position: 'absolute',
    bottom: '11px',
    right: '2px',
    margin: '0'
}

export default MediaItem;